<template>
    <div class="build_management">
        <div class="top_background_line"></div>
        <div class="management_wrap">
            <ul class="management_top">
                <li class="management_top_left">
                    <p>
                        <span class="management_name">{{name}}</span>
                        <span class="management_number">
                            总栋数：
                            <span>{{buildData.length}}栋</span>
                        </span>
                        <span class="management_number" style="padding-right:20px;">
                            总户数：
                            <span>{{households}}</span>
                        </span>
                        <span class="tylist">
                            (
                            <span v-if="areaShops!=0">商铺：{{areaShops}}户</span>
                            <span v-if="areaResidence!=0">住宅：{{areaResidence}}户</span>
                            <span v-if="areaBasement!=0">地下室：{{areaBasement}}户</span>
                            <span v-if="areaGarage!=0">车库：{{areaGarage}}户</span>
                            <span v-if="areaLand!=0">土地：{{areaLand}}户</span>
                            <span v-if="areaOfficeBuilding!=0">写字楼：{{areaOfficeBuilding}}户</span>
                            <span v-if="areaVilla!=0">别墅：{{areaVilla}}户</span>
                            <span v-if="areaWareHouse!=0">仓库：{{areaWareHouse}}户</span>
                            <span v-if="areaWorkShop!=0">厂房：{{areaWorkShop}}户</span>
                            <span v-if="areaOthers!=0">其他：{{areaOthers}}户</span>
                            )
                        </span>
                    </p>
                </li>
                <li class="management_top_right">
                    <el-button v-if="permisShow('楼栋编辑')" @click="editBuildShow">编辑楼栋</el-button>
                    <el-button v-if="permisShow('楼栋新增')" @click="addBuildBtns">添加楼栋</el-button>
                </li>
            </ul>
            <el-dialog title="新增楼栋" :visible.sync="dialogTableVisible" width="950px">
                <AddBuildAlert v-if="dialogTableVisible" v-on:removSaveBtn="removeBtn"
                    v-on:saveBuildingBtn="saveAddBuildBtn">
                </AddBuildAlert>
            </el-dialog>
            <el-dialog title="编辑楼栋" :visible.sync="editdialogTableVisible" width="950px">
                <EditBuildAlert v-if="editdialogTableVisible" :curBuildData="curBuildData"
                    v-on:removSaveBtn="editdialogTableVisible=false" v-on:saveBuildingBtn="saveEditBuildBtn">
                </EditBuildAlert>
            </el-dialog>
            <div class="management_list_wrap">
                <ul class="management_list">
                    <li class="management_list_item" :class="{active: isActive==item.tungId}"
                        v-for="(item,index) in buildData" :key="index" @click="getBuildInfo(item,'changeTung')">
                        <el-tooltip class="item" effect="dark" :content="item.tungNumber" placement="top-start">
                            <div>{{item.tungNumber}}</div>
                        </el-tooltip>
                    </li>
                </ul>
                <div class="build_info_box">
                    <div class="build_info_main">
                        <p class="build_info_first">
                            {{several}}
                            <span>信息</span>
                        </p>
                        <p class="build_info_second">
                            单元数：
                            <span>{{unitData.length}}</span>
                        </p>
                        <p class="build_info_second">
                            建筑年代：
                            <span>{{buildYear}}</span>
                        </p>
                        <p class="build_info_second">
                            户数：
                            <span>{{unithouseholds}}户</span>
                        </p>

                        <p class="build_info_second">
                            (
                            <span v-if="tungShops!=0">商铺：{{tungShops}}户</span>
                            <span v-if="tungResidence!=0">住宅：{{tungResidence}}户</span>
                            <span v-if="tungBasement!=0">地下室：{{tungBasement}}户</span>
                            <span v-if="tungGarage!=0">车库：{{tungGarage}}户</span>
                            <span v-if="tungLand!=0">土地：{{tungLand}}户</span>
                            <span v-if="tungOfficeBuilding!=0">写字楼：{{tungOfficeBuilding}}户</span>
                            <span v-if="tungVilla!=0">别墅：{{tungVilla}}户</span>
                            <span v-if="tungWareHouse!=0">仓库：{{tungWareHouse}}户</span>
                            <span v-if="tungWorkShop!=0">厂房：{{tungWorkShop}}户</span>
                            <span v-if="tungOthers!=0">其他：{{tungOthers}}户</span>
                            )
                        </p>
                    </div>
                    <!-- <div class="build_info_btns">
            <span>编辑</span>
            <span>删除</span>
                    </div>-->
                </div>
            </div>
            <div class="build_unit_situation">
                <ul class="situation_list" v-if="buildData.length!=0">
                    <li class="situation_title">显示租售情况</li>
                    <!-- <li class="situation_item orange" v-for="item in rentalData">
            <span>{{item.valueDesc}}：12</span>
            <div class="chouse_bj"></div>
            <i class="iconfont icon-duihao"></i>
                    </li>-->
                    <li class="situation_item"
                        :class="{yellow: index==0,red: index==1,green: index == 2,dark_green: index==3,blue: index==4}"
                        v-for="(item,index) in statusInfo" :key="index">
                        <span>{{item.status}}：{{item.num}}</span>
                    </li>
                    <li class="situation_item">
                        <span class="text">租售：{{rentAndSale}}</span>
                        <div class="yellow"></div>
                        <div class="red"></div>
                    </li>
                    <li class="situation_item">
                        <div class="yellow">
                            <span>在租：{{rentingNumber}}</span>
                        </div>
                    </li>
                    <li class="situation_item">
                        <div class="red">
                            <span>在售：{{saleNumber}}</span>
                        </div>
                    </li>
                    <li class="situation_item">
                        <div class="green">
                            <span>已租：{{rentAlreadyNumber}}</span>
                        </div>
                    </li>
                    <li class="situation_item">
                        <div class="dark_green">
                            <span>已售：{{soldNumber}}</span>
                        </div>
                    </li>
                    <li class="situation_item">
                        <div class="blue">
                            <span>成交：{{dealNumber}}</span>
                        </div>
                    </li>
                </ul>
            </div>
            <el-dialog title="编辑单元" :visible.sync="unitDialogVisible" width="380px">
                <div class="unitBox">
                    <div class="floor_item">
                        <div>
                            <div class="floor_tit">
                                <span style="color:red">*</span>名称
                            </div>
                            <div class="add_build_alert_building_info_content">
                                <el-input class="uiint_info_prefix" placeholder="前缀" v-model="editUnitDate.prefix">
                                </el-input>
                                <el-input class="uiint_info_floor" placeholder v-model="editUnitDate.number"></el-input>
                                <el-select class="uiint_info_unit" v-model="editUnitDate.suffix" placeholder>
                                    <el-option v-for="(item,index) in unitnameData" :key="index" :label="item.valueDesc"
                                        :value="item.value"></el-option>
                                </el-select>
                            </div>
                            <!-- <el-input v-model="editUnitDate.unitNumber"></el-input> -->
                        </div>
                    </div>
                    <!-- <div class="floor_item">
                        <div>
                            <div class="floor_tit">
                                <span style="color:red">*</span>单层户数
                            </div>
                            <div class="floor_item unitNum">
                                <el-input placeholder="请输入梯数" v-model="editUnitDate.elevatorNo"></el-input>
                                <span>梯</span>
                                <el-input placeholder="请输入户数" v-model="editUnitDate.households"></el-input>
                                <span>户</span>
                            </div>
                        </div>
                    </div>
                    <div class="floor_item">
                        <div>
                            <div class="floor_tit">是否有电梯</div>
                            <el-select v-model="editUnitDate.whetherElevator" placeholder="请选择">
                                <el-option
                                    v-for="(item,index) in stairsList"
                                    :key="index"
                                    :label="item.valueDesc"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>-->
                    <div class="footer_btn_wrap">
                        <el-button class="remove_btn" @click="removeSaveBtn">取消</el-button>
                        <el-button @click="saveUnitBtn" v-points>保存</el-button>
                    </div>
                </div>
            </el-dialog>
            <el-dialog :title="floorDialogName" v-if="floorDialogVisible" :visible.sync="floorDialogVisible"
                width="500px">
                <div class="floorBox">
                    <div class="floor_item">
                        <div class="floor_tit">
                            <div class>
                                <i style="color:#F56C6C;padding-right:3px;">*</i>所属楼层
                            </div>
                            <el-input v-model="editFloorDate.floorSource"></el-input>
                        </div>
                        <div>
                            <div class="floor_tit">
                                <i style="color:#F56C6C;padding-right:3px;">*</i>楼层名
                            </div>
                            <el-input v-model="editFloorDate.name"></el-input>
                        </div>
                    </div>
                    <div class="floor_item">
                        <div>
                            <div class="floor_tit">楼层用途</div>
                            <el-select v-model="editFloorDate.floorPurpose" placeholder="请选择"
                                @visible-change="getHouseUseData">
                                <el-option v-for="(item,index) in houseUseD" :key="index" :label="item.valueDesc"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <div class="floor_tit">所属层次</div>
                            <el-select v-model="editFloorDate.architecturalType" placeholder="请选择"
                                @visible-change="getBuildTypeData">
                                <el-option v-for="(item,index) in buildTypeD" :key="index" :label="item.valueDesc"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="footer_btn_wrap">
                        <el-button class="remove_btn" @click="removeSaveBtn">取消</el-button>
                        <el-button @click="saveFloorBtn" v-points>保存</el-button>
                    </div>
                </div>
            </el-dialog>

            <div class="rental_info">
                <el-dialog :title="houseVisibleTitle" :visible.sync="houseVisible" width="950px">
                    <AddHouse v-if="houseVisible" :houseDataSta="houseDataSta" :propRoomNumber="roomNumber"
                        :prophouseTypeId="houseTypeId" :propFrontage="propFrontage" :propRoomId="propRoomId"
                        :curTungId="isActive" :curFloorId="curFloorId" :curPurpose="curPurpose" :prosort="prosort"
                        v-on:imgshow="imgShow" @changehouseDataSta="changehouseDataStaF" @removeAddhouse="closeHouse" />
                </el-dialog>
                <ul class="rental_info_unit">
                    <!-- <li style="margin-left: 20px;" v-if="!unitData.findBuildDetailCell">没有此栋楼的单元信息</li> -->
                    <!-- 单元 -->
                    <li class="rental_info_unit_item" :class="{active:isActive2==item.unitId}"
                        v-for="(item,index) in unitData" :key="index" @click="getFloorRoomNrumer(item.unitId,index)">
                        <span v-if="item.unitNumber" @click="editUnit(item)" style="text-decoration:underline">{{item.unitNumber}}</span>
                        <span v-else>无单元</span>
                    </li>
                    <!-- 添加单元 -->
                    <li v-if="buildData.length>0&&permisShow('新增单元')" class="rental_info_unit_item" style="font-size: 50px" @click="addUnit">+</li>
                </ul>
                <div class="rental_info_foor">
                    <div v-if="floorData.length!=0"
                        style="font-size: 40px;color: #ccc;width: 82px;height: 50px;border:1px solid #ccc;text-align:center;margin-bottom:10px;cursor: pointer;"
                        @click="addFloor">+</div>
                    <ul v-for="(item,index) in floorData" :key="index">
                        <!-- 楼层 -->
                        <li @click="editFloor(item.floorId,item.floorNumber,item.floorName,item.architecturalType,item.floorPurpose)"
                            :style="editSta?'color:#000':''">
                            <span class="icon-status"
                                v-if="item.flage&&item.floorPurposeName">{{item.floorPurposeName}}</span>
                            <span class="text">{{item.floorName}}</span>
                            <!-- {{item.floorName}} -->
                            <div class="screening_tiaojian" v-if="editSta&&item.isActive">
                                <div class="chouse_bj" style="border-color:#5E75E6"></div>
                                <i class="iconfont icon-duihao"></i>
                            </div>
                            <div class="screening_tiaojian" v-else-if="editSta&&!item.isActive">
                                <div class="chouse_bj"></div>
                                <i class="iconfont icon-duihao"></i>
                            </div>
                        </li>
                        <li v-for="(list,indexL) in item.rooms"
                            @click="editHouse(list.roomId,list.roomName,list.frontage,list.houseTypeId,list.purpose,list.sort)"
                            :key="indexL" :style="editSta?'background:#FFF':''">
                            <span class="icon-status" v-if="!item.flage&&list.purposeName">{{list.purposeName}}</span>
                            <!-- <span class="text">{{list.roomName}} <i v-if="list.houseTypeId"
                                    :style="list.status?'color:#fff':'color:#0092ff'"
                                    class="iconfont icon-icon-huxingtu"></i></span> -->
                           <span class="text">{{list.roomName}} <i v-if="list.houseTypeId"
                                                                    :style="list.status.split('#')[0]=='在租'||list.status.split('#')[0]=='在售'||list.status.split('#')[0]=='已租'||list.status.split('#')[0]=='已售'||list.status.split('#')[0]=='成交'?'color:#fff':'color:#0092ff'"
                                                                   class="iconfont icon-icon-huxingtu"></i></span>
                            <div v-if="list.status.indexOf('#')<0 && !editSta"
                                :class="{yellow: list.status.split('#')[0]=='在租'?true:false,red: list.status.split('#')[0]=='在售'?true:false,green: list.status.split('#')[0]=='已租'?true:false,dark_green: list.status.split('#')[0]=='已售'?true:false,blue: list.status.split('#')[0]=='成交'?true:false}">
                            </div>
                            <div v-if="list.status.indexOf('#')>0 && !editSta">
                                <div
                                    :class="{yellow: list.status.split('#')[1]=='在租'?true:false,red: list.status.split('#')[1]=='在售'?true:false,green: list.status.split('#')[1]=='已租'?true:false,dark_green: list.status.split('#')[1]=='已售'?true:false,blue: list.status.split('#')[1]=='成交'?true:false}">
                                </div>
                                <div
                                    :class="{yellow: list.status.split('#')[0]=='在租'?true:false,red: list.status.split('#')[0]=='在售'?true:false,green: list.status.split('#')[0]=='已租'?true:false,dark_green: list.status.split('#')[0]=='已售'?true:false,blue: list.status.split('#')[0]=='成交'?true:false}">
                                </div>
                            </div>

                            <!-- 1{{list.isActive}} -->
                            <div class="screening_tiaojian" v-if="editSta&&list.isActive">
                                <div class="chouse_bj" style="border-color:#5E75E6"></div>
                                <i class="iconfont icon-duihao"></i>
                            </div>
                            <div class="screening_tiaojian" v-else-if="editSta&&!list.isActive">
                                <div class="chouse_bj"></div>
                                <i class="iconfont icon-duihao"></i>
                            </div>
                        </li>
                        <li v-if="permisShow('房间新增')" style="font-size: 40px;color: #ccc;"
                            @click="addHouseMask(item.floorId)">
                            <span class="text">+</span>
                        </li>
                    </ul>
                    <div v-if="floorData.length!=0" style="font-size: 40px;color: #ccc;width: 82px;height: 50px;border:1px solid #ccc;text-align:center;margin-bottom:10px;
                        cursor: pointer;" @click="addFloor">+</div>
                </div>
            </div>
            <el-dialog title="新增单元" :visible.sync="addUnitdialogTableVisible" width="600px">
                <addUnit :curBuildData="curBuildData" v-if="addUnitdialogTableVisible" v-on:removUnitBtn="removUnitBtn"
                               v-on:saveUnitsBtn="saveUnitsBtn">
                </addUnit>
            </el-dialog>
            <div class="build_info_btns" v-if="!editSta&&unitData.length!=0">
                <span v-if="permisShow('房间删除')" @click="deleteTung">删除</span>
                <!-- <span  @click="deleteTung">删除</span> -->
            </div>
            <div class="mask" v-if="imgListShow">
                <img class="close" @click="imgListShow=false" src="../../assets/images/close.png" alt />
                <img class="houseTypeimg" :src="'http://'+maskimgUrl" alt />
                <el-button class="delete" type="danger" @click="deleimg">删除</el-button>
                <el-button class="download" @click="downLoadImg('http://'+maskimgUrl)" type="primary">下载</el-button>
            </div>
            <div class="build_info_btns" v-else-if="editSta&&unitData.length!=0">
                <el-radio v-model="radio" label="1" @change="changeSlectHouse">全选</el-radio>
                <el-radio v-model="radio" label="2" @change="changeSlectHouse">反选</el-radio>
                <span @click="deleteTung">取消</span>
                <span @click="deleteconfirm">确认删除</span>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
/* eslint-disable */
import AddBuildAlert from "@/components/common/addBuild";
import addUnit from "@/components/common/addUnit";
import EditBuildAlert from "@/components/common/editBuild";
import AddHouse from "@/components/common/addhouse";
import {
    tungAdd,
    tungEdit,
    tungQuery,
    tungunitQuery,
    tungFloorUpdate,
    tungFloorAdd,
    tungFloorDelete,
    updateUnit,
    tungUpdateroom,
    addUnits
} from "@/api/manageCenter";
import { dicGet } from "@/api";
export default {
    // name: "楼栋管理",
    name: "/CommunityBuilds",
    components: {
        AddBuildAlert,
        AddHouse,
        EditBuildAlert,
        addUnit
    },
    data() {
        let permisList = JSON.parse(sessionStorage.getItem("permisList"));
        return {
            addUnitdialogTableVisible:false,
            permisList,
            name: "",
            imgListShow: false,
            maskimgUrl: "",
            residentialAreaId: "",
            dialogTableVisible: false,
            editdialogTableVisible: false,
            curBuildData: {}, //当前楼栋信息
            houseVisible: false,
            floorDialogVisible: false,
            dealNumber: "",
            households: "", //总户数
            unithouseholds: "", //单元户数
            areaShops: "", //商铺户数
            areaResidence: "", //住宅户数
            areaBasement: "", //地下室户数
            areaGarage: "", //车库户数
            areaLand: "", //土地户数
            areaOfficeBuilding: "", //写字楼户数
            areaVilla: "", //别墅户数
            areaWareHouse: "", //仓库楼户数
            areaWorkShop: "", //厂房楼户数
            areaOthers: "", //其他户数
            rentAlreadyNumber: "",
            rentAndSale: "",
            rentingNumber: "",
            saleNumber: "",
            soldNumber: "",
            unitNumber: "",
            totalHouseholdNum: "",
            buildYear: "",
            several: "",
            houseVisibleTitle: "新增房间",
            houseDataSta: true,
            isActive: -1, //激活的楼栋
            isActive2: -1, //激活的单元
            buildData: [],
            unitData: [],
            floorData: [],
            rentalData: [],
            statusInfo: [],
            buildTypeD: [], //建筑类型列表
            houseUseD: [], //楼层用途列表
            tungShops: "", //商铺户数
            tungResidence: "", //住宅户数
            tungBasement: "", //地下室户数
            tungGarage: "", //车库户数
            tungLand: "", //土地户数
            tungOfficeBuilding: "", //写字楼户数
            tungVilla: "", //别墅户数
            tungWareHouse: "", //仓库楼户数
            tungWorkShop: "", //厂房楼户数
            tungOthers: "", //其他户数
            stairsList: [
                { value: "NO", valueDesc: "否" },
                { value: "YES", valueDesc: "是" }
            ],
            unitDialogVisible: false, //编辑单元
            unitnameData: [], //单元名称列表
            editUnitDate: {
                number: "", //单元号
                suffix: "", //单元后缀
                prefix: "" //单元前缀
            },
            floorDialogName: "新增楼层",
            editFloorDate: {
                floorSource: "", //楼层来源
                floorId: "", //楼层id
                name: "", //楼层名
                floorPurpose: "", //楼层用途
                architecturalType: "" //建筑类型
            },
            editSta: false, //楼层是否为编辑状态
            curTungId: "", //当前的楼栋ID
            curFloorId: "", //当前的楼层ID
            curPurpose: "", //当前房间用途
            prosort: "", //当前房间顺序
            editFloorList: [],
            editHouseList: [],
            radio: "",
            propRoomId: "",
            roomNumber: "",
            propFrontage: "",
            houseTypeId: ""
        };
    },
    activated() {
        let oldId = sessionStorage.getItem("oldresidentialAreaId");
        let newId = sessionStorage.getItem("newresidentialAreaId") || "";
        if (oldId != newId) {
            this.name = sessionStorage.getItem("areaName");
            this.residentialAreaId = sessionStorage.getItem("newresidentialAreaId");
            this.getBuindData();
            this.getUnitData();
            this.isActive = -1;
            this.isActive2 = -1;
        }
    },
    beforeRouteLeave(to, from, next) {
        sessionStorage.setItem("oldresidentialAreaId", this.residentialAreaId);
         this.houseVisible = false
        next()
    },
    mounted() {
        this.name = sessionStorage.getItem("areaName");
        // 第一次进入页面
        this.residentialAreaId = sessionStorage.getItem("newresidentialAreaId");
        this.getBuindData();
        this.getUnitData();
    },
    methods: {
        //添加单元
        addUnit(){
            this.addUnitdialogTableVisible = true;
        },
        //取消
        removUnitBtn(){
         this.addUnitdialogTableVisible = false;
        },
        //新增单元
        saveUnitsBtn(val){
            console.log(val)
            this.$post(addUnits,val).then(res=>{
                if (res.success) {
                    this.addUnitdialogTableVisible = false;
                    this.$message.success(res.msg);
                    this.getBuildInfo(this.curBuildData)
                }else {
                    this.$message.error(res.msg)
                }
            })
        },
        permisShow(data) {
            // 权限配置
            let result = this.permisList.indexOf(data);
            if (result >= 0) {
                return true;
            } else {
                return false;
            }
        },
        // 查询栋楼
        getBuindData() {
            let params = {
                residentialAreaId: this.residentialAreaId
            };
            this.$post(tungQuery, params).then(res => {
                if (res.success) {
                    //cosole.log(res, '栋楼')
                    this.households = res.data.residentialAreaHouseHolds;
                    if (res.data.tungs.length == 0) {
                        console.log(1111);
                        this.buildData.splice(0, 100);
                        this.buildData = [];
                    } else {
                        this.buildData = res.data.tungs;
                    }
                    this.areaShops = res.data.shops;
                    this.areaResidence = res.data.residence;
                    this.areaBasement = res.data.basement;
                    this.areaGarage = res.data.garage;
                    this.areaLand = res.data.land;
                    this.areaOfficeBuilding = res.data.officeBuilding;
                    this.areaVilla = res.data.villa;
                    this.areaWareHouse = res.data.wareHouse;
                    this.areaWorkShop = res.data.workShop;
                    this.areaOthers = res.data.others;
                    // this.total = res.total
                    console.log(22222222, this.buildData.length);
                    if (this.buildData && this.buildData.length > 0) {
                        if (this.isActive > 0) {
                            let params = {};
                            this.buildData.map(item => {
                                if (item.tungId == this.isActive) {
                                    params = item;
                                }
                            });
                            params.tungId = this.isActive;
                            params.buildNumber = this.several;
                            params.buildYear = this.buildYear;
                            // (this.isActive2 = "");
                            this.getBuildInfo(params);
                        } else {
                            this.isActive = this.buildData[0].tungId;
                            this.several = this.buildData[0].buildNumber;
                            this.buildYear = this.buildData[0].buildingYears;
                            this.curBuildData = this.buildData[0];
                            this.isActive2 = "";
                            this.getBuildInfo(this.buildData[0]);
                        }
                    } else {
                        this.unitData = [];
                        this.floorData = [];
                        this.unithouseholds = 0;
                        this.buildYear = 0;
                        this.tungShops = 0;
                        this.tungResidence = 0;
                        this.tungBasement = 0;
                        this.tungGarage = 0;
                        this.tungLand = 0;
                        this.tungOfficeBuilding = 0;
                        this.tungVilla = 0;
                        this.tungWareHouse = 0;
                        this.tungWorkShop = 0;
                        this.tungOthers = 0;
                    }
                }
            });
        },
        // 查询租售情况
        geRrentalData() {
            let empId = sessionStorage.getItem("employeeId");
            let params = {
                employeeId: empId,
                code: "houseStatusEnums"
            };
            getScreening(params).then(res => {
                //cosole.log(res)
                if (res.success) {
                    this.rentalData = res.data;
                }
            });
        },
        // 查询栋楼单元
        getBuildInfo(item, sta) {
            this.curBuildData = item;
            console.log(213412321, this.curBuildData);
            if (sta == "changeTung") {
                this.isActive2 = "";
            }
            this.isActive = item.tungId;
            this.several = item.buildNumber;
            let params = {
                tungId: item.tungId
            };
            this.$post(tungunitQuery, params).then(res => {
                if (res.success) {
                    this.rentAlreadyNumber = res.data.rentAlreadyNumber;
                    (this.rentAndSale = res.data.rentAndSale),
                        (this.rentingNumber = res.data.rentingNumber);
                    this.saleNumber = res.data.saleNumber;
                    this.soldNumber = res.data.soldNumber;
                    this.dealNumber = res.data.dealNumber;
                    this.unithouseholds = res.data.households;
                    this.buildYear = res.data.buildYear;
                    this.tungShops = res.data.shops;
                    this.tungResidence = res.data.residence;
                    this.tungBasement = res.data.basement;
                    this.tungGarage = res.data.garage;
                    this.tungLand = res.data.land;
                    this.tungOfficeBuilding = res.data.officeBuilding;
                    this.tungVilla = res.data.villa;
                    this.tungWareHouse = res.data.wareHouse;
                    this.tungWorkShop = res.data.workShop;
                    this.tungOthers = res.data.others;

                    if (res.data.units.length > 0) {
                        this.unitData = res.data.units;
                        let flage = false;
                        this.unitData.map(item => {
                            if (
                                this.isActive2 &&
                                item.unitId == this.isActive2
                            ) {
                                flage = true;
                            }
                        });

                        if (this.isActive2 && flage) {
                            let curindex = 0;
                            this.unitData.map((item, index) => {
                                if (item.unitId == this.isActive2) {
                                    curindex = index;
                                }
                            });
                            this.getFloorRoomNrumer(this.isActive2, curindex);
                        } else {
                            this.isActive2 = this.unitData[0].unitId;
                            this.getFloorRoomNrumer(this.isActive2, 0);
                        }
                    } else {
                        this.unitData = [];
                        this.floorData = [];
                        this.isActive = -1;
                        this.getBuindData();
                    }
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },
        // 查询楼层和楼层房号
        getFloorRoomNrumer(unitId, index) {
            this.radio = 0;
            this.editHouseList = [];
            this.editFloorList = [];
            this.isActive2 = unitId;
            this.floorData = this.unitData[index].floors;
            this.floorData.map((item, index) => {
                item.isActive = false;
                item.flage = true;
                console.log(2131, item);
                if (item.rooms.length != 0) {
                    let curPurpose = item.rooms[0].purpose || "";
                    item.floorPurposeName = item.rooms[0].purposeName;
                    item.rooms.map((room, rindex) => {
                        room.isActive = false;
                        if (curPurpose != room.purpose) {
                            item.flage = false;
                        }
                    });
                }
            });
        },
        // 管理栋楼
        addBuildBtns() {
            this.dialogTableVisible = true;
        },
        removeBtn() {
            this.dialogTableVisible = false;
        },

        editBuildShow() {
            this.editdialogTableVisible = true;
        },

        // 查询建筑类型
        getBuildTypeData() {
            let params = {
                code: "floorType"
            };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    //cosole.log(res, '建筑类型')
                    this.buildTypeD = res.data;
                }
            });
        },
        getUnitData() {
            // 查询单元
            let params = {
                code: "unit"
            };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    //cosole.log(res)
                    this.unitnameData = res.data;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },
        // 查询房屋用途
        getHouseUseData() {
            let params = {
                code: "tungPurpose"
            };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    //cosole.log(res, '建筑类型')
                    this.houseUseD = res.data;
                }
            });
        },

        // 新增房间
        addHouseMask(id) {
            this.houseVisible = true;
            this.curFloorId = id;
            this.houseVisibleTitle = "新增房间";
            this.propRoomId = "";
            this.roomNumber = "";
        },

        // 关闭房间
        closeHouse() {
            this.houseVisible = false;
            this.getBuindData();
        },
        changehouseDataStaF() {
            this.houseDataSta = true;
        },

        deleimg() {
            if (this.houseVisibleTitle == "新增房间") {
                this.imgListShow = false;
                this.houseTypeId = "";
                this.houseDataSta = false;
            } else {
                let params = {
                    roomsId: this.propRoomId,
                    floorId: this.curFloorId,
                    roomNumber: this.roomNumber,
                    frontage: this.propFrontage,
                    roomId: this.propRoomId,
                    purpose: this.curPurpose,
                    sort: this.prosort
                };
                this.$post(tungUpdateroom, params).then(res => {
                    if (res.success) {
                        this.$message.success({
                            message: res.msg,
                            type: "success",
                            duration: 1000
                        });
                        this.imgListShow = false;
                        this.houseVisible = false;
                        sessionStorage.setItem("communitydelet", "del");
                        this.getBuindData();
                    } else {
                        this.imgListShow = false;
                        this.$message({
                            message: res.msg,
                            type: "error",
                            duration: 1000
                        });
                    }
                });
            }
        },

        editUnit(date) {
            // 编辑单元
            console.log(1111, date);
            if (date.unitNumber=='无单元') {
                return;
            }
            this.isActive2 = date.unitId;
            let result1 = this.permisShow("楼栋编辑");
            if (result1) {
                this.editUnitDate = Object.assign({}, date);
                this.unitDialogVisible = true;
            }
        },

        saveUnitBtn() {
            console.log(1111111111111, this.editUnitDate);
            if (!this.editUnitDate.number) {
                this.$message.error("名称不能为空");
                return false;
            }
            // else if (!this.editUnitDate.elevatorNo || this.editUnitDate.elevatorNo==0) {
            //     this.$message.error("梯数不能为空");
            //     return false;
            // } else if (!this.editUnitDate.households || this.editUnitDate.elevatorNo==0) {
            //     this.$message.error("户数不能为空");
            //     return false;
            // }
            let params = {
                tungId: this.isActive,
                unitId: this.editUnitDate.unitId,
                number: this.editUnitDate.number,
                suffix: this.editUnitDate.suffix,
                prefix: this.editUnitDate.prefix
                // elevatorNo: this.editUnitDate.elevatorNo,
                // households: this.editUnitDate.households,
                // whetherElevator: this.editUnitDate.whetherElevator
            };
            this.$post(updateUnit, params).then(res => {
                if (res.success) {
                    this.$message.success(res.msg);
                    this.getBuindData();
                    this.unitDialogVisible = false;
                    sessionStorage.setItem("communitydelet", "del");
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        addFloor() {
            this.floorDialogName = "新增楼层";
            let result = this.permisShow("楼层编辑");
            let result1 = this.permisShow("楼栋编辑");
            if (!result || !result1) {
                return false;
            }
            this.floorDialogVisible = true;
            this.editFloorDate = {
                floorSource: "", //楼层来源
                floorId: "", //楼层id
                name: "", //楼层名
                floorPurpose: "", //楼层用途
                architecturalType: "", //建筑类型
                unitId: this.isActive2
            };
        },
        // 编辑楼层
        editFloor(id, number, name, architecturalType, floorPurpose) {
            this.floorDialogName = "编辑楼层";
            let result = this.permisShow("楼层编辑");
            let result1 = this.permisShow("楼栋编辑");
            if (!result || !result1) {
                return false;
            }

            if (!this.editSta) {
                this.editFloorDate.floorId = id;
                this.editFloorDate.floorSource = number;
                this.editFloorDate.name = name;
                this.editFloorDate.architecturalType = architecturalType;
                this.editFloorDate.floorPurpose = floorPurpose;
                this.getBuildTypeData(true);
                this.getHouseUseData(true);
                this.floorDialogVisible = true;
            } else {
                this.floorData.map((item, index) => {
                    if (item.floorId == id) {
                        let sta = item.isActive;
                        delete item.isActive;
                        this.$set(item, "isActive", !sta);
                        item.rooms.map((room, rindex) => {
                            delete room.isActive;
                            this.$set(room, "isActive", !sta);
                            let isSave = this.editHouseList.indexOf(
                                room.roomId
                            );
                            if (isSave === -1) {
                                this.editHouseList.push(room.roomId);
                            } else {
                                this.editHouseList.splice(issave, 1);
                            }
                        });
                    }
                });
                let issave = this.editFloorList.indexOf(id);
                if (issave === -1) {
                    this.editFloorList.push(id);
                } else {
                    this.editFloorList.splice(issave, 1);
                }

                console.log(111, this.editFloorList);
                console.log(222, this.editHouseList);
            }
        },

        // 编辑房间
        editHouse(id, num, frontage, houseTypeId, purpose, sort) {
            if (id==0){
                return false
            }
            let result = this.permisShow("楼栋编辑");
            let result1 = this.permisShow("房间编辑");
            if (!result || !result1) {
                return false;
            }

            let isSave = this.editHouseList.indexOf(id);
            if (this.editSta) {
                if (isSave === -1) {
                    this.editHouseList.push(id);
                } else {
                    this.editHouseList.splice(isSave, 1);
                }
                this.floorData.map((item, index) => {
                    let activeNum = 0;
                    item.rooms.map((room, rindex) => {
                        if (room.roomId == id) {
                            let sta = room.isActive;
                            delete room.isActive;
                            this.$set(room, "isActive", !sta);
                        }
                        if (room.isActive) {
                            activeNum++;
                        }
                    });
                    if (
                        item.rooms.length == activeNum &&
                        item.rooms.length != 0
                    ) {
                        delete item.isActive;
                        this.$set(item, "isActive", true);
                    } else {
                        delete item.isActive;
                        this.$set(item, "isActive", false);
                    }
                });
            } else {
                this.houseVisibleTitle = "编辑房间";
                this.propRoomId = id;
                this.roomNumber = num;
                this.houseTypeId = houseTypeId;
                this.propFrontage = frontage;
                this.curPurpose = purpose;
                this.prosort = sort;
                this.houseVisible = true;
                //cosole.log(111111,houseTypeId)
            }
        },

        // 全选反选房间
        changeSlectHouse() {
            if (this.radio == 1) {
                this.editFloorList = [];
                this.editHouseList = [];
                this.floorData.map((item, index) => {
                    delete item.isActive;
                    this.$set(item, "isActive", true);
                    this.editFloorList.push(item.floorId);
                    item.rooms.map((room, rindex) => {
                        delete room.isActive;
                        this.$set(room, "isActive", true);
                        this.editHouseList.push(room.roomId);
                    });
                });
            } else {
                this.floorData.map((item, index) => {
                    let floorSta = item.isActive;
                    delete item.isActive;
                    this.$set(item, "isActive", !floorSta);
                    let activeNum = 0;
                    item.rooms.map((room, rindex) => {
                        let roomSta = room.isActive;
                        delete room.isActive;
                        this.$set(room, "isActive", !roomSta);
                        // console.log(
                        //     "editFloorList==========",
                        //     this.editFloorList
                        // );
                        let isSaveRoom = this.editHouseList.indexOf(
                            room.roomId
                        );
                        console.log("isSaveRoom==========", isSaveRoom);
                        if (isSaveRoom === -1) {
                            this.editHouseList.push(room.roomId);
                        } else {
                            this.editHouseList.splice(isSaveRoom, 1);
                        }
                        if (room.isActive) {
                            activeNum++;
                        }
                    });
                    // console.log(1111, this.editHouseList);
                    let isSaveFloor = this.editFloorList.indexOf(item.floorId);
                    if (item.rooms.length == 0) {
                        this.$set(item, "isActive", item.isActive);
                        if (this.editFloorList.indexOf(item.floorId) >= 0) {
                            this.editFloorList.splice(isSaveFloor, 1);
                        } else {
                            this.editFloorList.push(item.floorId);
                        }
                    } else if (item.rooms.length == activeNum) {
                        delete item.isActive;
                        this.$set(item, "isActive", true);
                        this.editFloorList.push(item.floorId);
                    } else {
                        delete item.isActive;
                        this.$set(item, "isActive", false);
                        this.editFloorList.splice(isSaveFloor, 1);
                    }
                });
            }
        },

        // 取消编辑楼层
        removeSaveBtn() {
            this.floorDialogVisible = false;
            this.unitDialogVisible = false;
        },

        // 删除楼层房间
        deleteTung() {
            this.editSta = !this.editSta;
            this.radio = "";
            if (this.editSta) {
                this.editFloorList = [];
                this.editHouseList = [];
                this.floorData.map((item, index) => {
                    delete item.isActive;
                    this.$set(item, "isActive", false);
                    item.rooms.map((room, rindex) => {
                        delete room.isActive;
                        this.$set(room, "isActive", false);
                    });
                });
            }
        },

        // 确认删除
        deleteconfirm() {
            this.$confirm("此操作将永久删除该房间, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    if (
                        this.editFloorList.length == 0 &&
                        this.editHouseList.length == 0
                    ) {
                        this.$message({
                            type: "error",
                            message: "请勾选房间或楼层"
                        });
                        return;
                    }
                    let params = {
                        floorsId: this.editFloorList,
                        roomsId: this.editHouseList,
                        tungId: this.isActive,
                        unitId: this.isActive2
                    };
                    this.$post(tungFloorDelete, params).then(res => {
                        if (res.success) {
                            this.$message({
                                type: "success",
                                message: res.msg
                            });
                            this.getBuindData();
                            this.editSta = false;
                            sessionStorage.setItem("communitydelet", "del");
                        } else {
                            this.$message({
                                type: "error",
                                message: res.msg
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                    this.editSta = false;
                });
        },

        imgShow(imgurl) {
            if (imgurl) {
                this.maskimgUrl = imgurl;
                this.imgListShow = true;
            }
        },

        // 编辑楼层
        saveFloorBtn() {
            if (!this.editFloorDate.name) {
                this.$message.error("楼层名不能为空");
                return;
            }
            if (!this.editFloorDate.floorSource) {
                this.$message.error("所属楼层不能为空");
                return;
            }
            var regNeg = /^\-[1-9][0-9]*$/; // 负整数
            if (
                !/(^[1-9]\d*$)/.test(this.editFloorDate.floorSource) &&
                !regNeg.test(this.editFloorDate.floorSource)
            ) {
                this.$message.error("所属楼层应为数字");
                return;
            }
            let params = this.editFloorDate;
            if (this.floorDialogName == "编辑楼层") {
                this.$post(tungFloorUpdate, params).then(res => {
                    if (res.success) {
                        this.$message({
                            type: "success",
                            message: res.msg
                        });
                        this.floorDialogVisible = false;
                        sessionStorage.setItem("communitydelet", "del");
                        this.getBuindData();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg
                        });
                    }
                });
            } else {
                this.$post(tungFloorAdd, params).then(res => {
                    if (res.success) {
                        this.$message({
                            type: "success",
                            message: res.msg
                        });
                        this.floorDialogVisible = false;
                        this.getBuindData();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg
                        });
                    }
                });
            }
        },

        // 保存楼栋
        saveAddBuildBtn(addBuildInfo) {
            addBuildInfo.residentialAreaId = this.residentialAreaId;
            //cosole.log(addBuildInfo, 'aaaa')
            this.$post(tungAdd, addBuildInfo).then(res => {
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: "success"
                    });
                    this.getBuindData();
                    this.dialogTableVisible = false;
                    sessionStorage.setItem("communitydelet", "del");
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },
        saveEditBuildBtn(editBuildInfo) {
            editBuildInfo.residentialAreaId = this.residentialAreaId;
            editBuildInfo.number = editBuildInfo.indexTung;
            editBuildInfo.prefix = editBuildInfo.tungPrefix;
            //cosole.log(addBuildInfo, 'aaaa')
            this.$post(tungEdit, editBuildInfo).then(res => {
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: "success"
                    });
                    this.getBuindData();
                    this.editdialogTableVisible = false;
                    sessionStorage.setItem("communitydelet", "del");
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },

        downLoadImg(item) {
            // 下载图片
            sessionStorage.setItem("downImg", item);
            this.$electron.ipcRenderer.send("open-directory-dialog");
        }
    }
};
</script>
<style lang="less">
.build_management {
    .screening_tiaojian {
        font-size: 12px;

        .chouse_bj {
            border-style: solid;
            border-width: 12px 12px 12px 12px;
            border-color: transparent transparent #bbb transparent;
            width: 0px;
            height: 0px;
            transform: rotate(45deg);
            // width: 10px;
            // height: 10px;
            background: #ccc;
            // border: 1px solid red;
            position: absolute;
            top: -12px;
            right: -12px;
        }

        .icon-duihao {
            font-size: 8px;
            position: absolute;
            right: 0;
            top: -20px;
            color: white;
        }
    }

    .build_info_btns {
        font-size: 18px;
        text-decoration: underline;
        display: flex;
        padding: 20px 0 0 400px;
        > span {
            margin-right: 20px;
            cursor: pointer;
            color: #5e75e6;
        }
    }

    .unitBox {
        padding: 0 0 20px 30px;
        text-align: left;
        .floor_item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .el-input__inner {
                width: 220px !important;
                height: 30px;
                font-size: 14px;
            }
            .floor_tit {
                height: 34px;
                line-height: 34px;
                font: 14px/34px "";
            }
            .add_build_alert_building_info_content {
                border: 1px solid #ccc;
                background: #f5f5f5;
                display: flex;
                margin-top: 10px;
                border-radius: 4px;
                overflow: hidden;

                .el-input {
                    .el-input__inner {
                        width: 65px !important;
                        height: 30px;
                        font-size: 14px;
                        background: #f5f5f5;
                        border: none;
                        border-right: 1px solid #ccc;
                        padding-left: 10px;
                        padding-right: 10px;
                        border-radius: 0;
                    }
                }

                .el-select {
                    .el-input {
                        .el-input__inner {
                            width: 65px !important;
                            height: 30px;
                            font-size: 14px;
                            background: #f5f5f5;
                            border: none;
                            padding-left: 6px;
                            padding-right: 10px;
                        }

                        .el-input__icon {
                            line-height: 30px;
                            width: 16px;
                            right: 0;
                        }
                    }
                }
            }
        }
        .unitNum {
            .el-input__inner {
                width: 100px !important;
                height: 30px;
                font-size: 14px;
                margin: 0 5px;
            }
        }

        .footer_btn_wrap {
            display: flex;
            justify-content: flex-end;
            margin-top: 50px;
            margin-bottom: 20px;
            margin-right: 20px;

            .el-button {
                width: 80px;
                height: 40px;
                background: #5e75e5;
                color: white;
                font-size: 16px;
                margin-left: 20px;

                &.remove_btn {
                    background: #bbb;
                }
            }
        }
    }

    .floorBox {
        padding: 20px;
        text-align: left;
        .floor_item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 18px;
            .el-input__inner {
                width: 220px !important;
                height: 30px;
                font-size: 14px;
            }
            .floor_tit {
                font: 14px/40px "";
            }
        }

        .footer_btn_wrap {
            display: flex;
            justify-content: flex-end;
            margin-top: 50px;
            margin-bottom: 20px;
            margin-right: 100px;

            .el-button {
                width: 80px;
                height: 40px;
                background: #5e75e5;
                color: white;
                font-size: 16px;
                margin-left: 20px;

                &.remove_btn {
                    background: #bbb;
                }
            }
        }
    }
}
</style>
<style type="text/css" lang="less" scoped>
.build_management {
    height: 100%;
    display: flex;
    flex-direction: column;
    .mask {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        .el-button {
            position: absolute;
            bottom: 100px;
            right: 300px;
            z-index: 100;
        }
        .delete {
            position: absolute;
            bottom: 100px;
            right: 300px;
            z-index: 100;
        }

        .download {
            border: none;
            background: #22ca85;
            color: #ffffff;
            position: absolute;
            bottom: 100px;
            right: 200px;
            z-index: 100;
        }
        .houseTypeimg {
            height: 70%;
        }
        .close {
            width: 20px;
            position: absolute;
            top: 100px;
            right: 300px;
            padding: 50px;
            z-index: 100;
        }
    }
    .top_background_line {
        height: 20px;
    }

    .management_wrap {
        flex: 1;
        background: white;
        padding: 30px;

        .management_top {
            display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
            display: -moz-box; /* 老版本语法: Firefox (buggy) */
            display: -ms-flexbox; /* 混合版本语法: IE 10 */
            display: -webkit-flex; /* 新版本语法: Chrome 21+ */
            display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
            -webkit-box-pack: justify;
            -moz-justify-content: space-between;
            -webkit-justify-content: space-between;
            justify-content: space-between;

            .management_top_left {
                .tylist {
                    span {
                        padding: 0px 5px;
                    }
                }
                > p {
                    display: flex;
                    align-items: flex-end;

                    .management_name {
                        font-size: 24px;
                        color: #5e75e6;
                    }

                    .management_number {
                        font-size: 18px;
                        margin-left: 20px;
                        color: #bbb;

                        > span {
                            color: #232323;
                        }
                    }
                }
            }

            .management_top_right {
                .el-button {
                    width: 130px;
                    height: 30px;
                    padding: 0;
                    line-height: 30px;
                    background: #5e75e6;
                    color: white;
                }
            }

            .el-dialog {
                width: 800px;

                .el-dialog__body {
                    padding: 30px 0 0 0;
                }
            }
        }

        .management_list_wrap {
            .management_list {
                display: flex;
                flex-wrap: wrap;
                margin-top: 20px;
                .management_list_item {
                    padding: 10px 5px;
                    white-space: nowrap;
                    width: 88px;
                    font-size: 18px;
                    margin-left: 10px;
                    margin-right: 20px;
                    border: 1px solid #ccc;
                    margin-top: 10px;
                    cursor: pointer;
                    div {
                        overflow: hidden;
                    }

                    &.active {
                        border: none;
                        background: #5e75e6;
                        color: white;
                    }
                }
            }

            .build_info_box {
                margin-left: 10px;
                margin-top: 20px;
                background: #f5f5f5;
                padding: 10px 0;
                display: flex;
                justify-content: space-between;

                .build_info_main {
                    display: flex;
                    align-items: center;

                    .build_info_first {
                        font-size: 20px;
                        color: #5e75e6;
                        margin-left: 20px;

                        > span {
                            font-size: 16px;
                        }
                    }

                    .build_info_second {
                        font-size: 16px;
                        margin-left: 30px;
                        color: #bbb;

                        > span {
                            color: #232323;
                            padding: 0 5px;
                        }
                    }
                }
            }
        }

        .build_unit_situation {
            display: flex;
            justify-content: flex-end;

            .situation_list {
                display: flex;
                align-items: center;
                margin-top: 30px;

                .situation_title {
                    margin-right: 30px;
                    font-size: 22px;
                    color: #232323;
                }

                .situation_item {
                    min-width: 100px;
                    height: 38px;
                    border: 1px solid #ccc;
                    position: relative;
                    overflow: hidden;
                    margin-right: 20px;
                    display: flex;
                    align-items: center;
                    position: relative;
                    span {
                        position: absolute;
                        min-width: 100px;
                        height: 38px;
                        text-align: center;
                        line-height: 38px;
                    }
                    div {
                        flex: 1;
                        height: 38px;
                    }
                    .brown {
                        color: #ffffff;
                        border: 1px solid #ff2a8e;
                        background: #ff2a8e;
                    }

                    .yellow {
                        color: #ffffff;
                        border: 1px solid #ff9021;
                        background: #ff9021;
                    }

                    .red {
                        color: #ffffff;
                        background: #f64e4e;
                        border: 1px solid #f64e4e;
                    }

                    .green {
                        color: #ffffff;
                        background: #49b165;
                        border: 1px solid #49b165;
                    }

                    .dark_green {
                        color: #ffffff;
                        background: #4995b1;
                        border: 1px solid #4995b1;
                    }

                    .blue {
                        color: #ffffff;
                        background: #5e75e6;
                        border: 1px solid #5e75e6;
                    }

                    // .chouse_bj {
                    //   border-style: solid;
                    //   border-width: 10px 10px 10px 10px;
                    //   border-color: transparent transparent #bbb transparent;
                    //   width: 0px;
                    //   height: 0px;
                    //   transform: rotate(45deg);
                    //   // width: 10px;
                    //   // height: 10px;
                    //   background: #ccc;
                    //   // border: 1px solid red;
                    //   position: absolute;
                    //   top: -10px;
                    //   right: -10px;
                    // }

                    // .icon-duihao {
                    //   font-size: 8px;
                    //   position: absolute;
                    //   right: 2px;
                    //   top: 0;
                    //   color: white;
                    // }

                    // &.active {
                    //   color: #5E75E6;
                    //   border: 1px solid #5E75E6;

                    //   >div {
                    //     color: #5E75E6;
                    //   }

                    //   .chouse_bj {
                    //     border-color: transparent transparent #5E75E6 transparent;
                    //   }
                    // }
                }
            }
        }

        .rental_info {
            display: flex;
            margin-top: 30px;

            .rental_info_unit {
                .rental_info_unit_item {
                    background: #f5f5f5;
                    color: #bbb;
                    padding: 30px 20px;
                    cursor: pointer;
                    margin-bottom: 4px;

                    &.active {
                        width: 72px;
                        color: #5e75e6;
                        background: #f4f6ff;
                        border-left: 4px solid #5e75e6;
                    }
                }
            }

            .rental_info_foor {
                margin-left: 30px;
                overflow-x: auto;
                > ul {
                    display: flex;
                    margin-bottom: 10px;

                    > li {
                        min-width: 80px;
                        height: 50px;
                        color: #000;
                        font-size: 18px;
                        border: 1px solid #ccc;
                        border-right: none;
                        text-align: center;
                        line-height: 50px;
                        // padding: 0 10px;
                        position: relative;
                        overflow: hidden;
                        cursor: pointer;
                        display: flex;
                        text-align: center;
                        .text {
                            position: absolute;
                            width: 100%;
                            text-align: center;
                            line-height: 50px;
                        }
                        div {
                            display: flex;
                            text-align: center;
                            flex: 1;
                        }
                        .icon-status {
                            position: absolute;
                            width: 40px;
                            height: 40px;
                            left: 0;
                            top: 0;
                            padding: 4px 0 0 4px;
                            font-size: 12px;
                            line-height: 12px;
                            text-align: left;
                            color: #ffffff;
                            background: url("../../assets/house_status.png")
                                no-repeat;
                        }
                        .yellow {
                            color: #ffffff;
                            border: 1px solid #ff9021;
                            background: #ff9021;
                        }

                        .red {
                            background: #f64e4e;
                        }

                        .green {
                            background: #49b165;
                        }

                        .dark_green {
                            background: #4995b1;
                        }

                        .blue {
                            background: #5e75e6;
                        }
                    }

                    > li:first-child {
                        color: #5e75e6;
                    }

                    > li:last-child {
                        border-right: 1px solid #ccc;
                    }
                }
            }
        }
    }
}
</style>
